<template>
  <h1>Hello world! 💚</h1>
  <p class="font-body-2">
    —
    <span rel="author"> Your Front-Office app </span>
  </p>
  <p>Using market country code: {{ market.market.countryCode }}</p>
  <button @click="onClick">Click me</button>
</template>

<script setup lang="ts">
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

const emit = defineEmits(['my-event'])

const onClick = () => {
  emit('my-event')
}

const market = useMarketplace()
</script>
